<template>
    <div class="wlx-candidate-table-wrapper">
        <div class="basic-head-main" :style="{ backgroundImage: 'url(' + headBg + ')' }">
            <div class="basic-head-con">
                <div class="head-title-con clearfix">
                    <div class="fl basic-book-img-con">
                        <img src="~assets/images/basic-book-img.png" alt />
                    </div>
                    <div class="fr head-title-word">
                        <p class="p-title-1">全国物流职业教育教学指导委员会下设专业委员会候选人推荐表</p>
                        <!-- <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="apply-table-content">
            <el-form :model="form" :rules="rules" ref="form">
                <table border="0" cellspacing="0" cellpadding="0">
                    <tr>
                        <td class="u-label-title">姓名</td>
                        <td colspan="2">
                            <el-input v-model="form.name" :disabled="isEdit"></el-input>
                        </td>
                        <td class="u-label-title">性别</td>
                        <td colspan="2">
                            <!-- <el-input v-model="form.sex" :disabled="isEdit"></el-input> -->
                            <el-select v-model="form.sex" placeholder="请选择" class="train-select-con" :disabled="isEdit">
                                <el-option label="男" value="男"></el-option>
                                <el-option label="女" value="女"></el-option>
                            </el-select>
                        </td>
                        <td colspan="2" class="u-label-title">出生日期</td>
                        <td colspan="2">
                            <!-- <el-input v-model="form.bornDate" :disabled="isEdit"></el-input> -->
                            <el-date-picker
                                v-model="form.bornDate"
                                :disabled="isEdit"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </td>
                        <td class="u-label-title">民族</td>
                        <td colspan="2">
                            <el-input v-model="form.national" :disabled="isEdit"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td class="u-label-title">单位</td>
                        <td colspan="2">
                            <el-input v-model="form.company" :disabled="isEdit"></el-input>
                        </td>
                        <td class="u-label-title">单位性质</td>
                        <td colspan="2">
                            <el-select placeholder="请选择" v-model="form.companyType" :disabled="isEdit">
                                <!-- <el-option label="本科" :value="1"></el-option>
                                <el-option label="企业" :value="2"></el-option> -->
                                <!-- <el-option label="中职" :value="3"></el-option> -->
                                <el-option label="高职" :value="1"></el-option>
                                <el-option label="中职" :value="3"></el-option>
                                <el-option label="企业" :value="2"></el-option>
                            </el-select>
                        </td>
                        <td colspan="2" class="u-label-title">职务</td>
                        <td colspan="2">
                            <el-input v-model="form.position" :disabled="isEdit"></el-input>
                        </td>
                        <td class="u-label-title">职称</td>
                        <td colspan="2">
                            <el-input v-model="form.workTitle" :disabled="isEdit"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td class="u-label-title">学历</td>
                        <td colspan="2">
                            <el-input v-model="form.education" :disabled="isEdit"></el-input>
                        </td>
                        <td class="u-label-title">学位</td>
                        <td colspan="2">
                            <el-input v-model="form.degree" :disabled="isEdit"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">毕业院校</td>
                        <td colspan="2">
                            <el-input v-model="form.schoolName" :disabled="isEdit"></el-input>
                        </td>
                        <td colspan="1" class="u-label-title">专业</td>
                        <td colspan="2">
                            <el-input v-model="form.majorName" :disabled="isEdit"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">研究方向</td>
                        <td colspan="6">
                            <el-input v-model="form.research" :disabled="isEdit"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">目前从事专业</td>
                        <td colspan="3">
                            <el-input v-model="form.workMajor" :disabled="isEdit"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">通讯地址</td>
                        <td colspan="6">
                            <el-input v-model="form.address" :disabled="isEdit"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">邮政编码</td>
                        <td colspan="3">
                            <el-input v-model="form.postalCode" :disabled="isEdit"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">联系电话</td>
                        <td colspan="6">
                            <el-input v-model="form.phone" :disabled="isEdit"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">手机</td>
                        <td colspan="3">
                            <el-input v-model="form.mobilephone" :disabled="isEdit"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">身份证号</td>
                        <td colspan="6">
                            <el-input v-model="form.idCard" :disabled="isEdit"></el-input>
                        </td>
                        <td colspan="2" class="u-label-title">电子邮箱</td>
                        <td colspan="3">
                            <el-input v-model="form.email" :disabled="isEdit"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">
                            拟推荐为
                        </td>
                        <td colspan="11" style="text-align: left">
                            <!-- <el-checkbox-group v-model="form.recommendType" :max="1" :disabled="isEdit" style="padding: 10px 10px">
                                <el-checkbox :label="1">物流管理专业工作组</el-checkbox>
                                <el-checkbox :label="2">物流工程专业工作组</el-checkbox>
                                <el-checkbox :label="3">采购管理专业工作组</el-checkbox>
                                <el-checkbox :label="4">青年教师工作组</el-checkbox>
                                <el-checkbox :label="5">冷链物流专业工作组</el-checkbox>
                                <el-checkbox :label="6">供应链管理专业工作组</el-checkbox>
                            </el-checkbox-group> -->
                            <el-select v-model="form.recommendType" placeholder="请选择" :disabled="isEdit">
                                <el-option label="高职现代物流管理专业委员会" :value="1"></el-option>
                                <el-option label="高职物流技术类专业委员会" :value="2"></el-option>
                                <el-option label="高职冷链物流技术与管理专业委员会" :value="3"></el-option>
                                <el-option label="高职航空物流管理专业专业委员会" :value="4"></el-option>
                                <el-option label="高职铁路与港口物流管理专业委员会" :value="5"></el-option>
                                <el-option label="高职工程物流管理专业委员会" :value="6"></el-option>
                                <el-option label="高职采购与供应链运营专业委员会" :value="7"></el-option>
                                <el-option label="高职本科物流类专业委员会" :value="8"></el-option>
                                <el-option label="中职物流管理与技术专业委员会" :value="9"></el-option>
                                <el-option label="中职国际货运代理专业委员会" :value="10"></el-option>
                                <el-option label="中职冷链物流服务与管理专业委员会" :value="11"></el-option>
                                <el-option label="师资建设专业委员会" :value="12"></el-option>
                                <el-option label="课程思政建设专业委员会" :value="13"></el-option>
                                <el-option label="两业融合专业委员会" :value="14"></el-option>
                                <el-option label="国际交流与合作专业委员会" :value="15"></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">工作简历</td>
                        <td colspan="11">
                            <el-input type="textarea" :disabled="isEdit" v-model="form.resume" :autosize="{ minRows: 8, maxRows: 24 }"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">学术成果</td>
                        <td colspan="11">
                            <el-input type="textarea" :disabled="isEdit" v-model="form.achievements" :autosize="{ minRows: 8, maxRows: 24 }"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="u-label-title">推荐单位意见</td>
                        <td colspan="11">
                            <el-input type="textarea" :disabled="isEdit" v-model="form.opinion" :autosize="{ minRows: 8, maxRows: 24 }"></el-input>
                        </td>
                    </tr>
                </table>
            </el-form>
            <!-- <p class="p-sign-up-tip p-sign-up-tip-1">支撑材料上传：（要求将最高学历证书、职称证书、推荐表盖章扫描件等材料，打包上传）</p>
            <applyFileUpload :url="urlAliyunOSS" :disabled="isEdit" v-if="isShow" :fileLists.sync="form.fileUrl" @done="onAllFilesUploadlLOU" @remove="remove" class="apply-file-upload"></applyFileUpload> -->
            <div class="submit-btn">
                <el-button type="primary" @click="fanhui">返回</el-button>
                <el-button type="primary" @click="getExportSQBUrl">导出word</el-button>
                <!-- <el-button type="primary" v-if="form.fileUrl!=null && form.fileUrl[0]" ><a  :href="form.fileUrl[0].url" style="color: #fff">导出文件</a> </el-button> -->
                <el-button type="primary" @click="submitTable('form')" v-if="!isEdit" :disabled="isSubmit">提交</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
import Bus from "components/bus.js";
import applyFileUpload from "components/uploads/uploadZip.vue";
export default {
    data() {
        return {
            isShow: false,
            files: [],
            urlAliyunOSS: "/api/design/osssign/getsign",
            headBg: require("assets/images/wlx-baic-bg-img.png"),
            form: {},
            showObject: {
                isShow: false,
            },
            isSubmit: false,
            rules: {
                name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
            },
            showTip: true,
            isEdit: ''
        };
    },
    components: {
        applyFileUpload,
    },
    props:{
        id:{
            type:String,
            default:""
        },
        isedit:{
            type:[Boolean,String],
            default:true
        }
    },
    created() {
        this.isEdit = Boolean(this.isedit);
        this.getCandidate();
    },
    methods: {
        getCandidate(){
            this.$http.post('/api/XOrg/Candidate/getCandidate',{
                id: this.id
            }).then( rst => {
                if(rst.code>0){
                    var newObj = {};
                    for(var k in rst.candidateInfo){
                        var newK = k.replace(k[0],k[0].toLowerCase());
                        newObj[newK] = rst.candidateInfo[k]
                    }
                    newObj.fileUrl = JSON.parse(newObj.fileUrl);
                    newObj.recommendType = Number([newObj.recommendType]);
                    this.form = newObj;
                    this.isShow = true;
                    console.log(newObj);    
                }
            })
        },
        fanhui() {
            this.$router.go(-1);
        },
        remove(){
            this.form.fileUrl = [];
        },
        onAllFilesUploadlLOU(val) {
            this.form.fileUrl.push(val);
        },
        submitTable(formName) {
            this.form.fileUrl;
            var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
            var email = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
            var idCard = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
            if (this.form.name == "") {
                this.$message({
                    message: "请输入姓名",
                    type: "warning",
                });
                return false;
            }
            if (this.form.sex === "") {
                this.$message({
                    message: "请选择性别",
                    type: "warning",
                });
                return false;
            }
            if (this.form.bornDate === "") {
                this.$message({
                    message: "请输入出生日期",
                    type: "warning",
                });
                return false;
            }
            if (this.form.national === "") {
                this.$message({
                    message: "请输入民族",
                    type: "warning",
                });
                return false;
            }
            if (this.form.company === "") {
                this.$message({
                    message: "请输入单位",
                    type: "warning",
                });
                return false;
            }
            if (this.form.companyType === "") {
                this.$message({
                    message: "请选择单位性质",
                    type: "warning",
                });
                return false;
            }
            if (this.form.workTitle === "") {
                this.$message({
                    message: "请输入职称",
                    type: "warning",
                });
                return false;
            }
            if (this.form.education === "") {
                this.$message({
                    message: "请输入学历",
                    type: "warning",
                });
                return false;
            }
            if (this.form.degree === "") {
                this.$message({
                    message: "请输入学位",
                    type: "warning",
                });
                return false;
            }
            if (this.form.majorName === "") {
                this.$message({
                    message: "请输入专业",
                    type: "warning",
                });
                return false;
            }
            if (this.form.research === "") {
                this.$message({
                    message: "请输入研究方向",
                    type: "warning",
                });
                return false;
            }
            if (this.form.workMajor === "") {
                this.$message({
                    message: "请输入目前从事专业",
                    type: "warning",
                });
                return false;
            }

            if (this.form.mobilephone == "") {
                this.$message({
                    message: "请输入号码",
                    type: "warning",
                });
                return false;
            } else if (!reg.test(this.form.mobilephone)) {
                this.$message({
                    message: "手机号格式不正确",
                    type: "warning",
                });
                return false;
            }
            if (this.form.email == "") {
                this.$message({
                    message: "请输入邮箱",
                    type: "warning",
                });
                return false;
            }else if(!email.test(this.form.email)){
                this.$message({
                    message: "邮箱格式不正确",
                    type: "warning",
                });
                return false;
            }
            if (this.form.recommendType == "") {
                this.$message({
                    message: "请勾选工作组",
                    type: "warning",
                });
                return false;
            }
            if (this.form.resume == "") {
                this.$message({
                    message: "请输入简历",
                    type: "warning",
                });
                return false;
            }
            if (this.form.achievements == "") {
                this.$message({
                    message: "请输入学术成果",
                    type: "warning",
                });
                return false;
            }
            if (this.form.opinion == "") {
                this.$message({
                    message: "请输入推荐单位意见",
                    type: "warning",
                });
                return false;
            }
            if (this.form.phone == "") {
                this.$message({
                    message: "请输入联系电话",
                    type: "warning",
                });
                return false;
            }
            if (this.form.schoolName == "") {
                this.$message({
                    message: "请输入毕业院校",
                    type: "warning",
                });
                return false;
            }
            if(this.form.idCard == "") {
                this.$message({
                    message: "请输入身份证号",
                    type: "warning",
                });
                return false;
            }else if (!idCard.test(this.form.idCard)) {
                this.$message({
                    message: "输入身份证号格式错误",
                    type: "warning",
                });
                return false;
            }
            if (this.form.position == "") {
                this.$message({
                    message: "请输入职务",
                    type: "warning",
                });
                return false;
            }
            if (this.form.address == "") {
                this.$message({
                    message: "请输入地址",
                    type: "warning",
                });
                return false;
            }
            // if (this.form.fileUrl.length == "") {
            //     this.$message({
            //         message: "请上传支撑材料",
            //         type: "warning",
            //     });
            //     return false;
            // }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isSubmit = true;
                    this.$http
                        .post("/api/XOrg/Candidate/addoreditInfo", {
                            id: this.id,
                            name: this.form.name,
                            sex: this.form.sex,
                            bornDate: this.form.bornDate,
                            national: this.form.national,
                            company: this.form.company,
                            companyType: this.form.companyType,
                            position: this.form.position,
                            workTitle: this.form.workTitle,
                            education: this.form.education,
                            degree: this.form.degree,
                            schoolName: this.form.schoolName,
                            majorName: this.form.majorName,
                            research: this.form.research,
                            workMajor: this.form.workMajor,
                            address: this.form.address,
                            postalCode: this.form.postalCode,
                            phone: this.form.phone,
                            mobilephone: this.form.mobilephone,
                            idCard: this.form.idCard,
                            email: this.form.email,
                            recommendType: this.form.recommendType,
                            resume: this.form.resume,
                            achievements: this.form.achievements,
                            opinion: this.form.opinion,
                            fileUrl: JSON.stringify(this.form.fileUrl),
                            type:1
                        })
                        .then((res) => {
                            if (res.code > 0) {
                                this.$message.success(res.msg);
                                this.$router.go(-1);
                            } else {
                                this.isSubmit = false;
                                this.$message({
                                    message: res.msg,
                                    type: "warning",
                                });
                            }
                        });
                } else {
                    this.$message({
                        message: res.msg,
                        type: "warning",
                    });
                    return false;
                }
            });
        },
        getExportSQBUrl(){
            if(this.id){
                window.location.href = "/api/XOrg/Candidate/exportSQBUrl?id="+this.id;
            }else{
                this.$message.warning('请先确定考核站点申请表信息');
            }
        },
    },
};
</script>

<style lang="scss">
.wlx-candidate-table-wrapper {
    height: 100%;
    overflow: auto;
    background: #f0f6ff;
    .basic-head-main {
        height: 706px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center top;
        .basic-head-con {
            margin: 0 auto;
            width: 1000px;
        }
        .head-logo-con {
            padding: 26px 0 0 26px;
        }
        .logo-img-val {
            height: 40px;
        }
        .head-title-con {
            position: relative;
            padding-top: 40px;
        }
        .basic-book-img-con {
            margin-left: 10px;
        }
        .head-title-word {
            position: absolute;
            right: 0;
            top: 80px;
            z-index: 100;
            color: #fff;
        }
        .p-title-1 {
            font-size: 27px;
            font-weight: bold;
            text-align: center;
            width: 610px;
        }
        .p-title-2-1 {
            margin-top: 50px;
            text-align: right;
            font-size: 20px;
        }
    }
    .apply-table-content {
        margin: -325px auto 0;
        padding: 20px 0;
        padding-top: 50px;
        width: 1000px;
        background: #fff;
    }
    .apply-file-upload {
        width: 380px;
        margin: 35px;
        .el-col-8 {
            margin-left: 9px;
        }
    }
    .p-down-applyTable-btn {
        text-align: right;
        color: #0365f5;
        padding: 0 22px 20px 0;
        cursor: pointer;
        font-size: 17px;
    }
    .apply-table-title {
        padding: 20px 0;
        text-align: center;
    }
    .submit-apply-btn {
        padding: 20px 0;
        text-align: center;
    }
    .label-job-con {
        padding: 0 20px;
    }
    table {
        margin: 0 auto;
        width: 960px;
        border-right: 1px solid #999;
        border-bottom: 1px solid #999;
        table-layout: fixed;
        word-break: break-all;
        background: #f0f0f0;
    }
    .u-label-title {
        font-weight: bold;
    }
    .demo-table {
        margin-top: 100px;
    }
    .expert-certify-ul {
        height: 100%;
    }
    .expert-certify-li {
        width: 25%;
    }
    .certify-li-cell {
        border-left: 1px solid #999;
        border-top: 1px solid #999;
    }
    .certify-li-cell-num {
        border-top: none;
    }
    .fistCertify {
        .certify-li-cell {
            border-left: none;
        }
    }
    .el-textarea__inner,
    .el-input__inner {
        border: none;
        font-size: 16px;
        color: #000;
    }
    .input-edu .el-input__inner {
        height: 82px;
        line-height: 82px;
    }
    .el-textarea__inner:focus {
        border: none;
    }
    .el-input__inner:focus {
        border: none;
    }
    .el-date-editor.el-input {
        width: 100%;
    }
    table td {
        border-left: 1px solid #999;
        border-top: 1px solid #999;
        text-align: center;
    }
    .label-opinion-title {
        padding: 10px;
        text-align: left;
    }
    .sp-mark-label {
        color: red;
    }
    .h4-major-title {
        padding: 10px 0;
    }
    td {
        height: 40px;
        // width: 76.9px;
        font-size: 16px;
    }
    .train-select-con {
        width: 100%;
    }
    .p-sign-up-tip {
        padding: 10px 0 0 20px;
    }
    .p-sign-up-tip-1 {
        margin-top: 40px;
    }
    .submit-btn {
        padding: 20px 0;
        text-align: center;
    }
    .wlx-is-fill-signUp-con {
        font-size: 16px;
        .p-name-pass-tip-con {
            margin-top: 10px;
            color: red;
        }
    }
    .train-sing-up-avatar-con {
        .el-upload-list--picture-card {
            .el-upload-list__item-thumbnail {
                width: auto;
            }
        }
    }
}
</style>
